import { components, numberToPxOrString, placements } from '@/utils'

import render from './render'

export default {
  name: 'Flag',

  props: {
    value: {
      type: String,
      default: undefined
    },

    size: {
      type: [ String, Number ],
      default: 15
    },

    tooltip: {
      type: Boolean,
      default: true
    },

    squircle: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    $_style() {
      const fontSize = numberToPxOrString(this.size)

      return {
        'font-size': fontSize,
        'line-height': fontSize
      }
    },

    $_tooltip() {
      if (this.tooltip) {
        return this.getTranslate(`countries.codes.${this.value}`)
      }
    },

    $_directives() {
      const result = []
      if (!this.squircle) {
        if (this.tooltip) {
          result.push({
            name: components.tooltip,
            options: {
              value: this.$_tooltip,
              placement: placements.top
            }
          })
        }
      }

      return result
    }
  },

  render
}
